import { Container, Link, LinkButton } from '@cluey/cluey-components';

import ReasonsToPause from '../../../../../components/hub/ReasonsToPause';
import {
  PATH_HUB_CHANGE_PLAN,
  PATH_HUB_ENROLMENT_DETAIL,
  PATH_HUB_SUMMER_PAUSE_ENROLMENT,
} from '../../../../../util/pagePath';

interface Props {
  enrolmentId: string;
  suggestSummerPause: boolean;
  policyName: string;
}
const PauseUnavailable = ({ enrolmentId, suggestSummerPause, policyName }: Props) => {
  return (
    <Container>
      {suggestSummerPause && (
        <div className="mb-10 rounded-lg bg-slate-1 px-4 pb-2 pt-2 md:px-10 md:pt-4">
          <ReasonsToPause title="Take a break for summer public school holidays" showSubText={false} />
          <div className="mb-6 mt-5 text-grey-6">
            <LinkButton
              className="mt-4"
              appearance="reverse"
              to={`${PATH_HUB_SUMMER_PAUSE_ENROLMENT}?token=${enrolmentId}`}
            >
              Pause for summer here
            </LinkButton>
          </div>
        </div>
      )}
      <div className="flex flex-col gap-3 text-grey-6">
        <p className="text-xl font-bold">
          Besides public school holidays, your {policyName} plan doesn't offer the flexibility to pause sessions during
          school terms.
        </p>
        {!suggestSummerPause && <p>You will be able to pause for the upcoming public school holidays soon.</p>}
        <p className="hidden">
          Want more flexibility? Try{' '}
          <Link className="!text-base underline underline-offset-2" to={PATH_HUB_CHANGE_PLAN}>
            switching to the Flexi plan.
          </Link>
        </p>
      </div>
      <LinkButton appearance="reverse" className="mt-7" to={`${PATH_HUB_ENROLMENT_DETAIL}?token=${enrolmentId}`}>
        Home
      </LinkButton>
    </Container>
  );
};

export default PauseUnavailable;
